module.exports = __webpack_public_path__ + "static/media/buildingOff_326.c541c226.png";